export const getMinErrorMessage = (name: string, min: number) => {
  return `${name} must be at least ${min}.`;
};

export const getMaxErrorMessage = (name: string, max: number) => {
  return `${name} must be at most ${max}.`;
};

export const getRequiredErrorMessage = (name: string) => {
  return `${name} is required.`;
};

export const getMustBeNumberErrorMessage = (name: string) => {
  return `${name} must be a number.`;
};
